import React from 'react';
// import SqlExcelBidirectionalConverter from '../../components/SqlExcelConverter/SqlExcelBidirectionalConverter';

const SqlExcelConverterPage: React.FC = () => {
  return (
    <div className="container mx-auto py-8">
      <h1>SQL Excel 双向转换工具</h1>
      {/* <SqlExcelBidirectionalConverter /> */}
    </div>
  );
};

export default SqlExcelConverterPage; 